import React from 'react';
import { Pane, Text, TextInput } from '@leverege/ui-elements';
import VehicleInfoCard from '../components/VehicleInfoCard';
import InputGroup from '../components/InputGroup';
import S from './SaleInformation.css';
import RecovrProductSelector from '../components/RecovrProductSelector';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SaleInformation(props) {
  const {
    onChange,
    vehicle,
    location,
    salesperson,
    productTypes
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: S.saleInformation,
    children: [/*#__PURE__*/_jsx(Pane, {
      layout: "flex:colL",
      children: /*#__PURE__*/_jsx(Text, {
        variant: "bodyBold",
        children: "Confirm Vehicle Sale Information"
      })
    }), /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colM",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bodyBold",
        children: "Vehicle Information"
      }), /*#__PURE__*/_jsx(VehicleInfoCard, {
        vehicle: vehicle
      })]
    }), /*#__PURE__*/_jsx(InputGroup, {
      eventData: "salesperson",
      onChange: onChange,
      editor: TextInput,
      value: salesperson,
      title: "Salesperson"
    }), /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bodyBold",
        children: "Select which RecovR products are included in this sale:"
      }), /*#__PURE__*/_jsx(RecovrProductSelector, {
        eventData: "productTypes",
        onChange: onChange,
        value: productTypes,
        location: location
      })]
    })]
  });
}
export default SaleInformation;